import { useAuth } from "react-oidc-context";

export const useOid = (): string => {
  const auth = useAuth();
  const oid = auth?.user?.profile?.oid;
  return typeof oid === "string" ? oid : "";
};